import { useLanguage } from "../context/LanguageContext";
import { Reveal } from "./motion";

export const FokusSection = () => {
  const { t } = useLanguage();
  const m = t.manifesto;
  return (
    <section data-testid="manifesto-section" className="bg-white">
      <div className="mx-auto max-w-[1600px] px-6 pt-28 sm:px-12 sm:pt-40 md:px-16">
        <Reveal y={14}>
          <p className="text-[13px] font-medium uppercase tracking-label text-wave">{m.label}</p>
        </Reveal>
      </div>

      <div className="relative mt-12">
        <div className="pointer-events-none absolute inset-0 lg:bottom-8 lg:top-16" aria-hidden="true">
          <img
            src="/images/welle1.webp"
            alt=""
            loading="lazy"
            className="h-full w-full object-cover"
            data-testid="manifesto-water"
          />
        </div>

        <div className="relative z-10 mx-auto max-w-[1600px] px-6 py-10 sm:px-12 sm:py-12 md:px-16 md:py-14 lg:py-0">
          <div className="flex flex-col gap-5 sm:gap-6 md:max-w-[640px] lg:max-w-[640px]">
            {m.chapters.map((ch, i) => (
              <Reveal key={ch.num} delay={i * 0.08}>
                <article
                  data-testid={`fokus-chapter-${i}`}
                  className="bg-deep p-7 transition-colors duration-500 hover:bg-ink sm:p-8 lg:p-9"
                >
                  <div className="flex items-baseline gap-3">
                    <span className="font-head text-2xl leading-none text-wave sm:text-3xl">{ch.num}</span>
                    <h3 className="font-head text-2xl leading-tight text-white sm:text-3xl">{ch.title}</h3>
                  </div>
                  <p className="mt-5 text-base font-light leading-relaxed text-white/70">{ch.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
      <div className="h-24 sm:h-28" aria-hidden="true" />
    </section>
  );
};
